export default "__VITE_ASSET__d4509752__"